import Vue from 'vue'
import { getI18nValueMap } from '@/api'

const preventReClick = Vue.directive('preventReClick', {
  inserted: function(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 3000)
      }
    })
  }
})
const Int = Vue.directive('Int', {
  inserted: function(el, binding) {
    el.addEventListener('keypress', function(e) {
      e = e || window.event
      const charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode
      const re = /\d/
      // console.log(charcode, re.test(String.fromCharCode(charcode)), charcode > 9, e.preventDefault, e)
      if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
      }
    })
  }
})

const number = Vue.directive('number', {
  bind(el, binding, vnode) {
    let input_ele
    const el_tagName = el.tagName.toUpperCase()
    if (el_tagName === 'INPUT') {
      input_ele = el
    } else {
      input_ele = el.getElementsByTagName('input')[0]
    }
    if (!input_ele) return

    function getValueMap(e) {
      var reg, res
      var val = input_ele.value

      if (binding.modifiers.positive && !binding.modifiers.float) { // 正整数.positive
        reg = /\D/g
        res = val.replace(reg, '')
      }
      if (!binding.modifiers.positive && !binding.modifiers.float) { // 默认正负整数
        reg = /\D/g
        res = val.replace(reg, '')
        if (val[0] === '-') res = '-' + res
      }
      function setFixed(val, digit) {
        var arr = val.split('.')
        if (arr.length < 2) return val
        return val.split('.')[0] + '.' + val.split('.')[1].slice(0, digit)
      }

      if (binding.modifiers.float) { // 小数
        var reg = /[^\.\d]/g
        res = val.replace(reg, '')
        res = res.split('')
        var flag = 0
        for (let i = 0; i < res.length;) {
          if (res[i] === '.') {
            flag++
            if (flag > 1) {
              res.splice(i, 1)
            } else {
              i++
            }
          } else {
            i++
          }
        }
        res = res.join('')// 正浮点数float.positive
        if (binding.modifiers.two)res = setFixed(res, 2)// 2位小数
        if (binding.modifiers.three)res = setFixed(res, 3)// 3位小数
        if (!binding.modifiers.positive) { // 正负浮点数.float
          if (val[0] === '-') {
            res = '-' + res
          }
        }
      }
      e = e || window.event
      const charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode
      const re = /\d/
      console.log(charcode, re.test(String.fromCharCode(charcode)), charcode > 9, 'res:', res, 'e.data:', e.data, e)
      var fromCharCode = re.test(String.fromCharCode(charcode))
      if ((!fromCharCode && charcode != 46) && charcode > 9 && !e.ctrlKey) {
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
      }
      if (charcode == 46) { // 避免输入多个小数点
        e.returnValue = res.indexOf('.') == -1
      }
      input_ele.value = res
      console.log(input_ele.value, '***', input_ele.value.length)
    }
    input_ele.addEventListener('keypress', (e) => { // keypress忽略了enter等键，导致中文时，输入字母再按enter，会讲字母显示在输入框中
      getValueMap(e)
    })
    input_ele.addEventListener('keyup', (e) => {
      getValueMap(e)
    })
  }

})

export { preventReClick, Int, number }
